import React, { useCallback, useEffect, useMemo, useState } from "react";

import { config, useSpring } from "@react-spring/core";
import { animated } from "@react-spring/web";

import { CardCollection } from "./CardCollection";
// import { AggregateBar } from "./AggregateBar";
import { CardSort } from "./CardSort";
import "./CardStack.scss";

export { Card } from "./CardCollection";

export const CardStack = ({
  data = [],
  className = "",
  groupBy = (d) => d,
  onCardHover = () => {},
  collapsed = false,
  histogramColor = (d) => `white`,
  showHistogram = true,
  showTableHeaders = true,
  show = true,
  sortFunc = (a, b) => 1,
  style = {},
  associationColor = (d) => `transparent`,
}) => {
  const [isCollapsed, setIsCollapsed] = useState(collapsed);
  const [currentPage, setCurrentPage] = useState(1);

  // if collapsed prop changes adjust state accordingly
  useEffect(() => {
    setIsCollapsed(collapsed);
  }, [collapsed]);

  const props = useSpring({
    opacity: Number(show),
    config: config.gentle,
  });

  useEffect(() => {
    // reset pagination when new data arrives
    setCurrentPage(1);
  }, [data]);

  const sortedData = useMemo(() => {
    const sorted = data;
    if (data.length === 0) return data;
    sorted.sort(sortFunc);
    return sorted;
  }, [data, sortFunc]);

  const showMoreEvents = useCallback(() => {
    setCurrentPage((curr) => curr + 1);
  }, []);

  return (
    <animated.div
      style={{ ...props, ...style }}
      className={`card-stack__container ${className} pb1 pl1 flex flex-column border-top rounded block-font`}
    >
      {/* <AggregateBar
        data={data}
        groupBy={groupBy}
        showHistogram={showHistogram}
        isCollapsed={isCollapsed}
        onCollapseToggle={() => setIsCollapsed((t) => !t)}
        histogramColor={histogramColor}
      /> */}
      <div
        className={`card-stack__expand ${
          !isCollapsed ? `card-stack__expand--open` : ``
        } uppercase self-center`}
      >
        {/* Hide */}
        <svg
          role="img"
          aria-label="expand card-stack"
          onClick={() => setIsCollapsed((isCollapsed) => !isCollapsed)}
        >
          <use xlinkHref="#chevron-down" />"
        </svg>
      </div>
      {isCollapsed ? (
        <div className="self-center">Show list of {data.length} events</div>
      ) : (
        <>
          {showTableHeaders && <CardSort className="h4 mt2 uppercase" />}
          <CardCollection
            associationColor={associationColor}
            cardsPerPage={25}
            className={"card-stack__card-list"}
            currentPage={currentPage}
            data={sortedData}
            onCardHover={onCardHover}
            onViewEnd={showMoreEvents}
          />
        </>
      )}
    </animated.div>
    // </div>
  );
};
